import { fitTextOnNLines } from "@remotion/layout-utils";
import { useEffect, useRef, useState } from "react";

const TITLE_BOX_HEIGHT = 240;
const TITLE_VERTICAL_PADDING = 40;
const TITLE_MAX_LINES = 2;
const titleLineHeightPx = Math.floor(
  (TITLE_BOX_HEIGHT - TITLE_VERTICAL_PADDING * 2) / TITLE_MAX_LINES,
);

export default function NewsSlidePreview({ news, styleSettings }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function updateScale() {
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      setScale(width / 1920);
    }
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full relative select-none"
      style={{
        aspectRatio: "16 / 9",
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {/* Background Image */}
        <img
          src={news.image}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Category top-left */}
        <div
          style={{
            position: "absolute",
            top: 40,
            left: 60,
            color: styleSettings?.slideItem?.category?.color || "#000",
            fontFamily: "Merriweather",
            fontSize: 48,
            fontWeight: "bold",
            backgroundColor: styleSettings?.slideItem?.category?.backgroundColor || "#fff",
            width: "max-content",
            height: "max-content",
            padding: 10,
          }}
        >
          {news.category}
        </div>

        {/* Title - positioned above subtitle */}
        <div
          style={{
            position: "absolute",
            paddingLeft: 60,
            paddingRight: 60,
            paddingTop: 40,
            paddingBottom: 40,
            color: styleSettings?.slideItem?.title?.color || "#000",
            fontFamily: "Merriweather",
            // fontSize: 48,
            fontWeight: "bold",
            backgroundColor: styleSettings?.slideItem?.title?.backgroundColor || "#fff",
            top: `calc(100% - ${TITLE_BOX_HEIGHT}px)`,
            bottom: 0,
            boxSizing: "border-box",
            lineHeight: `${titleLineHeightPx}px`,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: TITLE_MAX_LINES,
            WebkitBoxOrient: "vertical",
            fontSize: fitTextOnNLines({
              text: styleSettings?.slideItem?.title?.text ?? news.title,
              maxBoxWidth: 1920 - 120,
              maxLines: TITLE_MAX_LINES,
              fontFamily: "Merriweather",
              fontWeight: "bold",
              maxFontSize: titleLineHeightPx,
            }).fontSize,
          }}
        >
          {news.title}
        </div>
      </div>
    </div>
  );
}
